import { recaptchaId } from '../../constants';
export function generateRecaptchaToken() {
    const { grecaptcha } = window;
    if (grecaptcha == null)
        return null;
    return grecaptcha.execute(recaptchaId, { action: 'create' });
}
